"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const component_1 = require("../component");
exports.default = new class TagComponent extends component_1.default {
    defaultOptions = { padding: 2, bold: true };
    get(opts, p) {
        const tag = p.options.currentTag;
        if (!tag)
            return "??";
        opts.padding = tag.padding ?? 2;
        opts.background = tag.background;
        opts.color = tag.color || tag.textColor;
        opts.bold = tag.bold ?? true;
        opts.italic = tag.italic;
        opts.underline = tag.underline;
        opts.strikethrough = tag.strikethrough;
        return tag.text;
    }
    ;
};
